document.querySelectorAll( '.b-three-columns' ).forEach( ( block ) => {

    /////////////////////
    // BLOCK CODE HERE //
    /////////////////////

} );
    